const routerPT = {
    "releases": {
        "view": {
            "name": "Lançamentos",
            "buttonText": "Adicionar Novo Lançamento",
            "secondaryButtonText": "Transferir Lançamento",
            "headerText": "Lançamentos"
        },
        "add": {
            "name": "Adicionar Novo Lançamento",
            "headerText": "Lançamentos"
        },
        "update": {
            "name": "Atualizar Lançamento",
            "headerText": "Lançamentos"
        },
        "details": {
            "name": "Detalhes do Lançamento",
            "headerText": "Lançamentos"
        },
        "transfer": {
            "name": "Transferir Lançamento",
            "headerText": "Lançamentos"
        },
        "tracks": {
            "name": "Lista de Faixas",
            "headerText": "Lançamentos"
        },
        "deliveryConfirmation": {
            "name": "Lista de Entregues",
            "headerText": "Lista de Entregues"
        },
        "storeDeliveryList": {
            "name": "Lista de Entrega da Loja",
            "headerText": "Lista de Entrega da Loja"
        }
    },
    "copyrightInfringements": {
        "view": {
            "name": "Infrações de Direitos Autorais",
            "headerText": "Infrações de Direitos Autorais"
        }
    },
    "escrowWallet": {
        "view": {
            "name": "Carteira de Depósito",
            "headerText": "Carteira de Depósito"
        }
    },
    "artists": {
        "view": {
            "name": "Artistas",
            "buttonText": "Adicionar Novo Artista",
            "headerText": "Artistas"
        },
        "add": {
            "name": "Adicionar Novo Artista",
            "headerText": "Artistas"
        },
        "update": {
            "name": "Atualizar Artista",
            "headerText": "Artistas"
        },
        "viewDetails": {
            "name": "Ver Detalhes do Artista",
            "headerText": "Ver Detalhes do Artista"
        },
        "wishlist": {
            "name": "Lista de Desejos de Artistas",
            "headerText": "Lista de Desejos de Artistas"
        },
        "addFromWishlist": {
            "name": "Adicionar Artista da Lista de Desejos",
            "headerText": "Adicionar Artista da Lista de Desejos"
        }
    },
    "trends": {
        "view": {
            "name": "Tendências",
            "headerText": "Tendências"
        }
    },
    "earningsDrilldown": {
        "view": {
            "name": "Ganhos",
            "headerText": "Detalhamento de Ganhos"
        }
    },
    "accounting": {
        "view": {
            "name": "Contabilidade Inteligente",
            "headerText": "Contabilidade Inteligente",
            "buttonText": "Adicionar Nova Contabilidade"
        },
        "add": {
            "name": "Adicionar Nova Contabilidade",
            "headerText": "Adicionar Nova Contabilidade"
        },
        "breakdown": {
            "name": "Detalhamento Contábil",
            "headerText": "Detalhamento Contábil"
        }
    },
    "invoices": {
        "view": {
            "name": "Faturas",
            "headerText": "Faturas",
            "buttonText": "Adicionar Fatura"
        },
        "add": {
            "name": "Adicionar Fatura",
            "headerText": "Adicionar Fatura"
        }
    },
    "musicLink": {
        "view": {
            "name": "Link de Música",
            "buttonText": "Adicionar Novo Link de Música",
            "headerText": "Link de Música",
            "secondaryButtonText": "URL do Link de Música"
        },
        "add": {
            "name": "Adicionar Link de Música",
            "headerText": "Link de Música"
        },
        "update": {
            "name": "Atualizar Link de Música",
            "headerText": "Link de Música"
        },
        "viewStats": {
            "name": "Estatísticas de Visualização do Link de Música",
            "headerText": "Estatísticas de Visualização do Link de Música"
        }
    },
    "musicLinkUrlpart": {
        "view": {
            "name": "Parte da URL do Link de Música",
            "buttonText": "Adicionar Nova Parte da URL do Link de Música",
            "headerText": "Parte da URL do Link de Música"
        },
        "add": {
            "name": "Adicionar Nova Parte da URL do Link de Música",
            "headerText": "Parte da URL do Link de Música"
        },
        "update": {
            "name": "Atualizar Parte da URL do Link de Música",
            "headerText": "Parte da URL do Link de Música"
        }
    },
    "linkLandingPage": {
        "view": {
            "name": "Página de Destino do Link",
            "buttonText": "Adicionar Página de Destino do Link",
            "headerText": "Página de Destino do Link"
        },
        "add": {
            "name": "Adicionar Página de Destino do Link",
            "headerText": "Página de Destino do Link"
        },
        "update": {
            "name": "Atualizar Página de Destino do Link",
            "headerText": "Página de Destino do Link"
        },
        "viewAnalytics": {
            "name": "Análise da Página de Destino do Link",
            "headerText": "Página de Destino do Link"
        }
    },
    "mastering": {
        "view": {
            "name": "Masterização",
            "buttonText": "Adicionar Masterização",
            "headerText": "Masterização de Áudio"
        },
        "add": {
            "name": "Adicionar Masterização",
            "headerText": "Masterização de Áudio"
        },
        "update": {
            "name": "Atualizar Masterização",
            "headerText": "Masterização de Áudio"
        },
        "viewSongs": {
            "name": "Músicas de Masterização de Áudio",
            "headerText": "Músicas de Masterização de Áudio"
        }
    },
    "featureRequest": {
        "view": {
            "name": "Solicitação de Recurso",
            "buttonText": "Nova Solicitação de Recurso",
            "headerText": "Solicitação de Recurso"
        },
        "add": {
            "name": "Adicionar Solicitação de Recurso",
            "headerText": "Solicitação de Recurso"
        }
    },
    "scWhitelist": {
        "view": {
            "name": "Lista Branca SC",
            "headerText": "Lista Branca SC"
        }
    },
    "profile": {
        "view": {
            "name": "Perfil",
            "headerText": "Meu Perfil"
        }
    },
    "announcements": {
        "view": {
            "name": "Anúncios",
            "headerText": "Anúncios"
        }
    },
    "twoFactorAuthentication": {
        "view": {
            "name": "Autenticação de Dois Fatores",
            "headerText": "Autenticação de Dois Fatores"
        }
    },
    "completeYourInformation": {
        "view": {
            "name": "Complete Suas Informações",
            "headerText": "Complete Suas Informações"
        }
    },
    "tokens": {
        "view": {
            "name": "Tokens",
            "headerText": "Tokens"
        }
    },
    "orderTokens": {
        "view": {
            "name": "Pedir Tokens",
            "headerText": "Pedir Tokens"
        }
    },
    "accessKeys": {
        "view": {
            "name": "Chaves de acesso",
            "headerText": "Chaves de acesso"
        }
    },
    "paymentMethods": {
        "view": {
            "name": "Métodos de Pagamento",
            "buttonText": "Adicionar Método de Pagamento",
            "headerText": "Meus Métodos de Pagamento"
        },
        "add": {
            "name": "Adicionar Método de Pagamento",
            "headerText": "Meus Métodos de Pagamento"
        },
        "update": {
            "name": "Atualizar Método de Pagamento",
            "headerText": "Meus Métodos de Pagamento"
        }
    },
    "orderCredits": {
        "view": {
            "name": "Créditos de Pedido",
            "headerText": "Créditos de Pedido"
        }
    },
    "purchaseHistory": {
        "view": {
            "name": "Histórico de Compras",
            "headerText": "Histórico de Compras"
        }
    },
    "subscription": {
        "view": {
            "name": "Minha Assinatura",
            "headerText": "Minha Assinatura"
        },
        "upgrade": {
            "name": "Atualizar Assinatura",
            "headerText": "Atualizar Assinatura"
        }
    },
    "subUsers": {
        "view": {
            "name": "Subusuários",
            "buttonText": "Adicionar Novo Subusuário",
            "headerText": "Meus Subusuários"
        },
        "add": {
            "name": "Adicionar Novo Subusuário",
            "headerText": "Meus Subusuários"
        },
        "edit": {
            "name": "Editar Subusuário",
            "headerText": "Meus Subusuários"
        }
    },
    "labels": {
        "view": {
            "name": "Gravadoras",
            "buttonText": "Adicionar Nova Gravadora",
            "headerText": "Minhas Gravadoras"
        },
        "add": {
            "name": "Adicionar Nova Gravadora",
            "headerText": "Minhas Gravadoras"
        },
        "edit": {
            "name": "Editar Gravadora",
            "headerText": "Minhas Gravadoras"
        }
    },
    "statements": {
        "view": {
            "name": "Extratos",
            "headerText": "Extratos Financeiros"
        }
    },
    "subuserStatements": {
        "viewParentUser": {
            "name": "Extratos de Subusuário",
            "headerText": "Extratos de Subusuário"
        },
        "viewSubuser": {
            "name": "Extratos do Usuário",
            "headerText": "Extratos do Usuário"
        }
    },
    "dashboard": {
        "view": {
            "name": "Página Inicial",
            "headerText": "Página Inicial"
        }
    }
};

export default routerPT;